export default "__VITE_ASSET__d05494ad__"